import { ValidationService } from 'src/services/validation/validation.service';

export const addEditValidations = new ValidationService([
  {
    name: 'start',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'Start cannot be empty'
      }
    ]
  },
  {
    name: 'end',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'End cannot be empty'
      }
    ]
  },
  {
    name: 'price',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'Price cannot be empty'
      }
    ]
  },
  {
    name: 'quantityLimit',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'quantityLimit cannot be empty'
      }
    ]
  },
  {
    name: 'itemId',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'Item cannot be empty'
      }
    ]
  },
  {
    name: 'media',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'You have to upload a media'
      }
    ]
  },
  {
    name: 'mediaLandScape',
    type: 'text',
    value: '',
    validations: [
      {
        type: { name: 'notEmpty' },
        message: 'You have to upload a media'
      }
    ]
  }
]);
